export const headerConfig = {
  headerTitle: "Payment History",
  headerDescription: "List of Payment History",
  refreshButton: {
    id: 'refresh',
    label: 'Refresh',
    icon: 'RefreshIcon',
  },
};
